/**
 * What the browser keeps (ADR-29): the enrolled device (id + secret, "something you have") survives restarts;
 * the session token lives only for this tab and dies with the idle lock. The PIN is never stored.
 */

export interface DeviceCreds {
  deviceId: string;
  deviceSecret: string;
  door: "customer" | "staff";
  displayName: string;
  pinLength: 4 | 6;
}

export interface SessionInfo {
  token: string;
  context: "customer" | "staff";
}

const DEVICE_KEY = "kitchen.device";
const SESSION_KEY = "kitchen.session";

// The stored JSON shape is named by the caller.
// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-parameters
function read<T>(storage: () => Storage, key: string): T | null {
  try {
    const raw = storage().getItem(key);
    return raw ? (JSON.parse(raw) as T) : null;
  } catch {
    return null;
  }
}
function write(storage: () => Storage, key: string, value: unknown): void {
  try {
    if (value === null) storage().removeItem(key);
    else storage().setItem(key, JSON.stringify(value));
  } catch {
    // Private mode or blocked storage: the user simply signs in again next time.
  }
}

export const loadDevice = () => read<DeviceCreds>(() => localStorage, DEVICE_KEY);
export const saveDevice = (d: DeviceCreds | null) => {
  write(() => localStorage, DEVICE_KEY, d);
};
export const loadSession = () => read<SessionInfo>(() => sessionStorage, SESSION_KEY);
export const saveSession = (s: SessionInfo | null) => {
  write(() => sessionStorage, SESSION_KEY, s);
};
